import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-assessment-plan-and-record-achievement',
  templateUrl: './assessment-plan-and-record-achievement.component.html',
  styleUrls: ['./assessment-plan-and-record-achievement.component.scss']
})
export class AssessmentPlanAndRecordAchievementComponent implements OnInit {


  exerciseReferral
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  singleLearner: any;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  sign = false
  sign1 = false
  sign2 = false
  sign3 = false
  sign4 = false
  sign5 = false
  sign6 = false
  sign7 = false
  sign8 = false
  learnerSign = false
  assesorSign = false
  assesorSign1 = false
  assesorSign2 = false
  assesorSign3 = false
  assesorSign4 = false
  loading = false
  isEdit: boolean = false
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService : UserRoleService
    // public cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.jobId = changes.jobData.currentValue[0]
      this.getUserRole();
    }
    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);


      if (this.assessmentPlanEdit && this.assessmentPlanEdit.exerciseReferral) {
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign != "") {
          this.sign = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign1 != "") {
          this.sign1 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign2 != "") {
          this.sign2 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign3 != "") {
          this.sign3 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign4 != "") {
          this.sign4 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign5 != "") {
          this.sign5 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign6 != "") {
          this.sign6 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign7 != "") {
          this.sign7 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.sign8 != "") {
          this.sign8 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.learnerSign != "") {
          this.learnerSign = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.assesorSign != "") {
          this.assesorSign = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.assesorSign1 != "") {
          this.assesorSign1 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.assesorSign2 != "") {
          this.assesorSign2 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.assesorSign3 != "") {
          this.assesorSign3 = true
        }
        if (this.assessmentPlanEdit.exerciseReferral && this.assessmentPlanEdit.exerciseReferral.assesorSign4 != "") {
          this.assesorSign4 = true
        }
      }
      this.isEdit = true
      this.createForm(this.assessmentEdit)

    } else {
      this.createForm()
    }
  }

  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobId.instructors,'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if(getRole.isLearner) this.isLearner = true
    else if(getRole.isTrainer) this.isTrainer = true
    else if(getRole.isIQA) this.isIQA = true

  }


  // FORM CONTROL


  createForm(details?) {
    this.exerciseReferral = new FormGroup({
      centerName: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.centerName : ''),
      date: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date : ''),
      date1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date1 : ''),
      date2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date2 : ''),
      date3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date3 : ''),
      date4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date4 : ''),
      date5: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date5 : ''),
      date6: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date6 : ''),
      date7: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date7 : ''),
      date8: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.date8 : ''),
      score: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score : ''),
      score1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score1 : ''),
      score2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score2 : ''),
      score3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score3 : ''),
      score4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score4 : ''),
      score5: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score5 : ''),
      score6: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score6 : ''),
      score7: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score7 : ''),
      score8: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.score8 : ''),
      initialDate: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate : ''),
      initialDate1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate1 : ''),
      initialDate2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate2 : ''),
      initialDate3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate3 : ''),
      initialDate4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate4 : ''),
      initialDate5: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate5 : ''),
      initialDate6: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate6 : ''),
      initialDate7: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate7 : ''),
      initialDate8: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.initialDate8 : ''),
      iv: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv : ''),
      iv1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv1 : ''),
      iv2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv2 : ''),
      iv3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv3 : ''),
      iv4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv4 : ''),
      iv5: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv5 : ''),
      iv6: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv6 : ''),
      iv7: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv7 : ''),
      iv8: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.iv8 : ''),
      sign: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign : ''),
      sign1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign1 : ''),
      sign2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign2 : ''),
      sign3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign3 : ''),
      sign4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign4 : ''),
      sign5: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign5 : ''),
      sign6: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign6 : ''),
      sign7: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign7 : ''),
      sign8: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.sign8 : ''),
      learnerName: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.learnerName : ''),
      learnerSign: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.learnerSign : ''),
      learnerDate: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.learnerDate : ''),
      assesorName: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorName : ''),
      assesorSign: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorSign : ''),
      assesorDate: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorDate : ''),
      assesorName1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorName1 : ''),
      assesorSign1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorSign1 : ''),
      assesorDate1: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorDate1 : ''),
      assesorName2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorName2 : ''),
      assesorSign2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorSign2 : ''),
      assesorDate2: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorDate2 : ''),
      assesorName3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorName3 : ''),
      assesorSign3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorSign3 : ''),
      assesorDate3: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorDate3 : ''),
      assesorName4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorName4 : ''),
      assesorSign4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorSign4 : ''),
      assesorDate4: new FormControl((details && details.exerciseReferral) ? details.exerciseReferral.assesorDate4 : ''),
    })
  }



  // UTILITY


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addSignature(fomrControl) {
    if ((this.isLearner || this.isIQA) && ((fomrControl == 'sign1') || (fomrControl == 'sign2') || (fomrControl == 'sign3') || (fomrControl == 'sign4') || (fomrControl == 'sign5') || (fomrControl == 'sign6') || (fomrControl == 'sign7') || (fomrControl == 'sign8') || (fomrControl == 'sign') || (fomrControl == 'assesorSign') || (fomrControl == 'assesorSign1') || (fomrControl == 'assesorSign2') || (fomrControl == 'assesorSign3'))) {
    }
    else if ((this.isTrainer || this.isIQA) && (fomrControl == 'learnerSign')) {
      // this.exerciseReferral.get('learnerSign').disable()
    }
    else if (this.isLearner && (fomrControl == 'assesorSign4')) {
      // this.exerciseReferral.get('assesorSign4').disable()
    }
    else {
      this.openDialog(SignaturePadComponent).subscribe((data) => {
        console.log("data of sign", data);
        if (data == undefined) return

        let newSign = data

        if (fomrControl == 'sign') {
          this.sign = true
          this.exerciseReferral.patchValue({
            sign: newSign
          })
        }
        if (fomrControl == 'sign1') {
          this.sign1 = true
          this.exerciseReferral.patchValue({
            sign1: newSign
          })
        }

        if (fomrControl == 'sign2') {
          this.sign2 = true
          this.exerciseReferral.patchValue({
            sign2: newSign
          })
        }

        if (fomrControl == 'sign3') {
          this.sign3 = true
          this.exerciseReferral.patchValue({
            sign3: newSign
          })
        }

        if (fomrControl == 'sign4') {
          this.sign4 = true
          this.exerciseReferral.patchValue({
            sign4: newSign
          })
        }

        if (fomrControl == 'sign5') {
          this.sign5 = true
          this.exerciseReferral.patchValue({
            sign5: newSign
          })
        }

        if (fomrControl == 'sign6') {
          this.sign6 = true
          this.exerciseReferral.patchValue({
            sign6: newSign
          })
        }

        if (fomrControl == 'sign7') {
          this.sign7 = true
          this.exerciseReferral.patchValue({
            sign7: newSign
          })
        }

        if (fomrControl == 'sign8') {
          this.sign8 = true
          this.exerciseReferral.patchValue({
            sign8: newSign
          })
        }


        if (fomrControl == 'learnerSign') {
          this.learnerSign = true
          this.exerciseReferral.patchValue({
            learnerSign: newSign
          })
        }

        if (fomrControl == 'assesorSign') {
          this.assesorSign = true
          this.exerciseReferral.patchValue({
            assesorSign: newSign
          })
        }
        if (fomrControl == 'assesorSign1') {
          this.assesorSign1 = true
          this.exerciseReferral.patchValue({
            assesorSign1: newSign
          })
        }
        if (fomrControl == 'assesorSign2') {
          this.assesorSign2 = true
          this.exerciseReferral.patchValue({
            assesorSign2: newSign
          })
        }
        if (fomrControl == 'assesorSign3') {
          this.assesorSign3 = true
          this.exerciseReferral.patchValue({
            assesorSign3: newSign
          })
        }
        if (fomrControl == 'assesorSign4') {
          this.assesorSign4 = true
          this.exerciseReferral.patchValue({
            assesorSign4: newSign
          })
        }

      })
    }


  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'exerciseReferral')
      this.exerciseReferral.get(formControl).setValue(value);
  }

  // API CALL

  submitForm() {
    console.log("first part value", this.exerciseReferral.value);
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId._id,
      version: true,
      details: {
        exerciseReferral: this.exerciseReferral.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }


}
